export const API =
  process.env.REACT_APP_API_BASE || "https://image.bvhvgl.com/api";
export const IMAGE_BASE =
  process.env.REACT_APP_IMAGE_BASE || "https://image.bvhvgl.com";


export async function login(username, password) {
  const res = await fetch(`${API}/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password }),
  });
  return res.json();
}

export async function getFolderContent(path = "") {
  const res = await fetch(`${API}/folder?path=${encodeURIComponent(path)}`);
  return res.json();
}

export async function createFolder(parent, folderName) {
  const res = await fetch(`${API}/folder/create`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ parent, folderName }),
  });
  return res.json();
}

export async function deleteFile(path, name) {
  const res = await fetch(
    `${API}/delete-file?path=${encodeURIComponent(path)}&name=${encodeURIComponent(name)}`,
    { method: "DELETE" }
  );
  return res.json();
}

export async function renameFile(path, oldName, newName) {
  const res = await fetch(`${API}/rename-file`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ path, oldName, newName }),
  });
  return res.json();
}

export async function deleteFolder(path) {
  const res = await fetch(
    `${API}/delete-folder?path=${encodeURIComponent(path)}`,
    { method: "DELETE" }
  );
  return res.json();
}

export async function renameFolder(parent, oldName, newName) {
  const res = await fetch(`${API}/rename-folder`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ parent, oldName, newName }),
  });
  return res.json();
}

// ===== DOWNLOAD =====
export async function downloadFiles(path, files) {
  const res = await fetch(`${API}/download`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ path, files }),
  });
  if (!res.ok) throw new Error("Download failed");

  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = files.length === 1 ? files[0] : "download.zip";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
 
export async function compressSelected(path, files, force = false) {
  const res = await fetch(`${API}/compress-selected`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ path, files, force }),
  });
  return res.json();
} 
export async function compressAll(path = "", force = false, targetMb = 1) {
  const res = await fetch(
    `${API}/compress-all?path=${encodeURIComponent(path)}&force=${force}&target_mb=${targetMb}`,
    { method: "POST" }
  );
  return res.json();
}
